import { useContext, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useParams } from 'react-router';
import { MapContext } from '../contexts/MapContext';

// Resets the Apollo cache and map state when the farmId changes
const useResetFarmEffect = () => {
  const { farmId } = useParams();
  const { resetState } = useContext(MapContext);
  const client = useApolloClient();

  useEffect(() => {
    return () => {
      resetState();
      client.resetStore();
    };
  }, [farmId]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useResetFarmEffect;
